import { INITIALIZE_SUCCESS, SET_BREADCRUMBS, SET_LAST_BREADCRUMBS,
  PUSH_BREADCRUMBS, SET_PAGE_HEAD } from "../constants/app";

const initialState = {
  isInitialized: undefined,
  breadcrumbs: null,
  pageHead: null,

  difficulties: [],
  tonalities: [],
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_SUCCESS:
      return {
        ...state,
        isInitialized: true,
      };
    case SET_BREADCRUMBS:
      return {
        ...state,
        breadcrumbs: action.breadcrumbs,
      };
    case SET_LAST_BREADCRUMBS:
      const lastIndex = state.breadcrumbs.length - 1;
      return {
        ...state,
        breadcrumbs: state.breadcrumbs.map((b, index) => {
          if (index === lastIndex) return action.breadcrumbs;
          return b;
        })
      };
    case PUSH_BREADCRUMBS:
      return {
        ...state,
        breadcrumbs: [...state.breadcrumbs, action.breadcrumbs]
      };
    case SET_PAGE_HEAD:
      return {
        ...state,
        pageHead: action.pageHead,
      };
    default:
      return state;
  }
};

export default appReducer;